import React from "react";
import "./Common_Luxury_Card.css";

const Common_Luxury_Card = ({ img, title, descn }) => {
  return (
    <div className="blue_card">
      <div className="img_holder">
        {img && <img src={img} alt={title} className="inner_img" />}
      </div>

      <div className="text_div">
        <p className="title_text">{title}</p>
        {descn && <p className="descn_text">{descn}</p>}
      </div>
    </div>
  );
};

export default Common_Luxury_Card;